import { Discount } from '../types/discounts';

export enum DiscountType {
    'discountInNok',
    'discountInAmount',
    'discountInPercentage',
    'amountBuyDiscount',
    'fixedPriceDiscount',
    'loyalty',
}

export enum LoyaltyType {
    'visitAndSpending',
    'productsBought',
}

export enum LoyaltyDiscountType {
    'inPercentage',
    'inCurrency',
    'freeItem',
}

export interface Campaign {
    name: string;
    dateFrom: Date;
    dateTo: Date;
    timeFrom: Date;
    timeTo: Date;
    visibleFrom: number;
    discounts: DiscountItem[];
    locationType: LocationType;
    storeIds: string[];
    audienceType: AudienceType;
    audienceUserIds: string[];
    audience: {
        name: string;
        location: string;
    }[];
    mccs: string[];
    mccRanges: [string, string][];
}

export interface DiscountItem {
    id: string;
    type: DiscountType;
    loyaltyType: LoyaltyType;
    loyaltyDiscountType: LoyaltyDiscountType;
    discountValue: string;
    totalPurchase: string;
    payFor: string;
    discountUsageAmount: string;
    discountCombination: 0 | -1 | undefined;
    items: Item[];
    groupItems: GroupItems;
    title: string;
    description: string;
    visitsNumber: string;
    minimumPurchase: string;
    requirements: Requirement[];
    itemsBought: string;
    validFor: string;
    emailSendout: boolean;
    metadata_dintero_exclude_public_description?: string;
    webshop?: string;
}

export interface Item {
    name?: string;
    id: string;
    groupId?: string;
    isBlacklisted: boolean;
}

export enum GroupItems {
    allItems,
    itemsGrouped,
}

export enum LocationType {
    allLocations,
    predefinedLocations,
    mcc,
}

export enum AudienceType {
    allAudience,
    predefinedAudience,
    userIds,
}

export interface Requirement {
    timeFrom: Date;
    timeTo: Date;
    day: string;
}

export enum Stage {
    'discounts',
    'locations',
    'publication',
    'success',
}

export interface AssetRequestObject {
    file: Blob;
    discountId: string;
}

export interface AssetResponseObject {
    public_url: string;
    upload_url: string;
    upload_expires_in: number;
}

export interface DiscountToEdit extends DiscountItem {
    dateFrom: Date;
    dateTo: Date;
    timeFrom: Date;
    timeTo: Date;
}

export interface DiscountWithStatus extends Discount {
    status?: 'active' | 'scheduled' | 'completed' | 'deleted';
}

export interface ProductCatalog {
    catalog_id: string;
    catalog_name: string;
    id: string;
}

export interface Product {
    id: string;
    product_id: string;
    product_name: string;
    catalog_id: string;
    catalog_name: string;
    description: string;
    is_virtual_product: boolean;
    unit_gross_price: number;
    unit: string;
    currency: string;
}
